import { render } from "./YouWillLeave.vue?vue&type=template&id=cdaba7bc&scoped=true"
import script from "./YouWillLeave.vue?vue&type=script&lang=js"
export * from "./YouWillLeave.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdaba7bc"]])

export default __exports__